<div class="feed-agreement-dialog">
  <div class="task-head">
    <h4>{{ title }}</h4>
  </div>
  <p>{{ message }}</p>

  <div class="btns">
    <button mat-stroke-button type="button" class="custom-button" (click)="cancel()">{{ cancelLabel }}</button>
    <button mat-flat-button type="button" class="submit" (click)="agree()">{{ agreeLabel }}</button>
  </div>
</div>
